// extracted by mini-css-extract-plugin
module.exports = {"viewBtn":"Dialog_viewBtn__Vtn5j","icon":"Dialog_icon__1oI6H"};